import React, { useContext, useState, Suspense, useEffect } from "react";
import SimpleContext from "./../context/SimpleContext";
import search1 from "../img/search.png";
import cross from "../img/cross.png";
import SearchBrands from "./SearchBrands";
import { useHistory } from "react-router";
import NumberFormat from "react-number-format";
import Preloader from "../Preloader/preloader";
import Preloader2 from "../Preloader/preloader2";
import InfiniteScroll from "react-infinite-scroll-component";
import BuyBtn from "../Buttons/BuyBtn";
import "./categories.css";
import brands from "./../img/brands.png";
import Basket from "../img/Basket.png";
import useLocalStorageState from "use-local-storage-state";
import { Button, Modal } from "react-bootstrap";
const CategoriesProducts = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();

  const [showModal, setshowModal] = useState(false);
  const [img, setimg] = useState([]);
  const [search, setsearch] = useState(false);
  const [pre, setpre] = useState(false);
  const [sortName, setsortName] = useState("");

  let styleLenght = context.category.length;

  //فراخانی وب سرویس sortorder
  useEffect(() => {
    context.sortOrder();
    context.search(
      0,
      context.SearchField,
      0,
      context.showCatId,
      context.SelectedBrandsList,
      context.sort,
      context.justFav,
      0,
      0,
      context.searchBodyOfProduct
    );
    if (context.List.length > 0) {
      let name;
      name = context.List.find((i) => i.id === context.sort);
      setsortName(name.title);
    }
  }, []);

  //عوض شدن ظاهر صفحه با توجه به بودن یا نبودن المان ها
  let searchCat={
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItem: "center",
    textAlign: "center",
    gap: "10px",
    width:'100%',
    height:'50px',
    marginTop:'10px'
  }

  let filterOrSortPart;
  if(context.uisetting!==null&&context.uisetting!==undefined){
    if(Object.values(context.uisetting).length>0){
      if(context.uisetting.filterVisibility===true){
        filterOrSortPart ={
          height:'50px'
        }
      }else{
        filterOrSortPart ={
          height:'0'
        }
      }
    }
  }
  let headerCat ={
    fontWeight: "bold",
    color: "gray",
    paddingRight: "4%",
    display: "flex",
    alignItems: "center",
    margin: "0",
    height:'50px'
  }

  let filterOrSortPartBrands;
  if(context.searchProducts!==null&&context.searchProducts!==undefined){
    if(Object.values(context.searchProducts).length > 0){
        if( context.searchProducts.brandList.length > 0 &&
          context.SelectedBrandsList.length === 0 ||context.goBrand===true){
            filterOrSortPartBrands ={
              width: "100%",
              position: "relative",
              marginRight: "10px",
              height:'70px'
            }
        }else{
          filterOrSortPartBrands ={
            width: "100%",
            position: "relative",
            marginRight: "10px",
            height:'0'
            }
        }
    }
  }
  // if(context.category.length > 0 &&
  //   context.showCatId !== 0 &&
  //   context.BrandOfId !== 0){
  //   filterOrSortPartBrands ={
  //   width: "100%",
  //   position: "relative",
  //   marginRight: "10px",
  //   height:'70px'
  // }
  // }else{
  //   filterOrSortPartBrands ={
  //   width: "100%",
  //   position: "relative",
  //   marginRight: "10px",
  //   height:'0'
  //   }
  // }
  let filterOrSortPartBrands2;
  if(context.category!==null && context.category!==undefined ){
    if(context.category.length > 0 &&
      context.showCatId !== 0 &&
      context.BrandOfId !== 0){
      filterOrSortPartBrands2 ={
      width: "100%",
      position: "relative",
      marginRight: "10px",
      height:'70px'
      }
    }else{
      filterOrSortPartBrands2 ={
      width: "100%",
      position: "relative",
      marginRight: "10px",
      height:'0'
      }
    }
  }
  // let NotfilterOrSortPartBrands ={
  //   width: "150px",
  //   position: "relative",
  //   marginRight: "10px",
  //   height:'70px'
  // }
  // let filterOrSortPartBrands ={
  //   width: "150px",
  //   position: "relative",
  //   marginRight: "10px",
  //   height:'70px'
  // }
  let catStyle;
  if(filterOrSortPartBrands2!==undefined&&filterOrSortPartBrands2!==null&&
    filterOrSortPartBrands!==undefined&&filterOrSortPart!==undefined&&headerCat!==undefined){

     catStyle = {
      marginTop:`${parseInt(filterOrSortPartBrands2.height) + parseInt(filterOrSortPartBrands.height) +
        parseInt(headerCat.height) + parseInt(filterOrSortPart.height) + parseInt(searchCat.height) + 20}px`
    };
  }else{
    catStyle = {
      marginTop:"120px"
       
    };
  }

  

  // فراخانی وب سرویس جستجوی محصولات پس از اضافه شدن پیج
  useEffect(() => {

    if (context.page !== 0) {
      context.search(
        context.page,
        context.SearchField,
        0,
        context.showCatId,
        context.SelectedBrandsList,
        context.sort,
        context.justFav,
        0,
        0,
        context.searchBodyOfProduct
      );
      context.categories(context.showCatId, context.SelectedBrandsList);
    }
  }, [context.page]);

  //برای هندل کردن ارور عکس ها
  const addDefaultSrc = (ev) => {
    ev.target.src = "/images/placeholder.jpg";
  };

  // let filteredCats = context.category.filter((cat) => cat.ID !== 9);
  //تابع برای فراخانی محصو.لات بیشتر با استفاده ار پیجینیشن
  const fetchData = () => {
    setTimeout(() => {
      context.setpage(context.page + 1);
    }, 150);
  };

  //تابع برای نمایش مودال که عکس هارا نشان میدهد
  const ModalImage = (img) => {
    setshowModal(true);
    setimg(img);
  };
  //برای جست وجو با اینتر
  function handleKeyPress(e) {
    if (e.key === "Enter") {
      setsearch(true);
      context.setshow(false);
      HandleSearch();
    }
  }

  //تابع برای سرچ محصولات
  const searchh = () => {
    HandleSearch();
  };
  const HandleSearch = () => {
    context.setsearchProducts({})
    context.setshowPre(true)
    context.setshowCat(true);
    context.setTreeMenuSelectedId(0);
    context.setFilterPriceRange([0, 0]);
    context.setSelectedBrandsList([]);
    context.search(
      0,
      context.SearchField,
      0,
      context.showCatId,
      context.SelectedBrandsList,
      context.sort,
      context.justFav,
      0,
      0,
      context.searchBodyOfProduct
    );
    context.categories(context.showCatId, context.SelectedBrandsList);
  };

  //تابع برای حذف کردن مقدار سرچ شده
  const HandlecleareAllAndReload = () => {
    context.setshowPre(true)
    context.setTreeMenuSelectedId(0);
    context.setSearchField("");
    context.setFilterPriceRange([0, 0]);
    context.setSelectedBrandsList([]);
    context.setpage(0);
    context.search(
      0,
      "",
      0,
      context.showCatId,
      context.SelectedBrandsList,
      context.sort,
      context.justFav,
      0,
      0,
      context.searchBodyOfProduct
    );
    context.categories(context.showCatId, context.SelectedBrandsList);
  };

  //نمایش محصولات ساب کتگوری ها
  const goSub2 = (name, id) => {
    setpre(true)
    context.setshowPre(true)
    context.setgoBrand(false)
    context.setshowCatId(id);
    context.setheaderCat(name);
    context.categories(id, context.SelectedBrandsList);
    context.search(
      0,
      "",
      0,
      id,
      context.SelectedBrandsList,
      context.sort,
      context.justFav,
      0,
      0,
      context.searchBodyOfProduct
    );
  };
  //نمایش محصولات برندها
  const gobrands = (name, id) => {
    context.setshowPre(true)
    context.setgoBrand(false)
    context.SelectedBrandsList.push(id);
    context.setheaderCat(name);
    context.categories(context.showCatId, id);
    context.search(
      0,
      "",
      0,
      context.showCatId,
      context.SelectedBrandsList,
      context.sort,
      context.justFav,
      0,
      0,
      context.searchBodyOfProduct
    );
    context.setgoBrand(true)
  };
  //رفتن به صفحه جزییات محصول با شناسه کاربر
  const ShowProductInfo = (product) => {
    if(parseInt(product.stock) === 0||parseInt(product.stock) < 0){
      context.Handelerror(product.stockToast)
    }else{
      history.push(`/product/${product.productRef}`);
      context.setproductRoight(product.productRef);
      
    }
  };

  //تابع برای حذف برندهای انتخاب شده
  const removeFilter=() => {
    context.setgoBrand(false)
    context.categories(context.showCatId, []);
    context.search(
      0,
      "",
      0,
      context.showCatId,
      [],
      context.sort,
      context.justFav,
      0,
      0,
      context.searchBodyOfProduct
    );
  }



  return (
    <>
    {
      Object.values(context.searchProducts).length===0?
      <Preloader/>
      :
    <div
      style={{
        display: "flex",
        width: "97%",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      {context.showPre === true && context.page === 0? (
        <Preloader />
      ) : (
        <>
          <div className="searchCat">
            <div
            style={searchCat}
            >
              <div
                style={{ position: "relative" }}
                id="ss"
                className="searchPart"
              >
                <button type="submit" className="btn btn-sm">
                  <img
                    onClick={() => searchh()}
                    alt="آیکون"
                    src={search1}
                    style={{ width: "20px" }}
                  />
                </button>
                <input
                  onChange={(e) => context.setSearchField(e.target.value)}
                  onKeyDown={(e) => handleKeyPress(e)}
                  className="searchInput"
                  type="text"
                  placeholder={
                    context.SearchField !== ""
                      ? context.SearchField
                      : "جستجوی محصول"
                  }
                  style={{
                    border: "none",
                    backgroundColor: "#d9d6d6",
                    color: "gray",
                    fontSize: "15px",
                    outline: "none",
                    width: "100%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "13px",
                  }}
                />

                <button type="submit" className="btn btn-sm">
                  <img
                    onClick={() => HandlecleareAllAndReload()}
                    src={cross}
                    style={{
                      fontSize: "24px",
                      width: "15px",
                      margin: "2px 0 0 0 ",
                    }}
                  />
                </button>
              </div>

              <div className="searchPart2">
                <img style={{ width: "25px" }} src={Basket} />
                {context.BadgeOfBasket > 0 && (
                  <div
                    onClick={() => history.push("/Buy")}
                    style={{
                      width: "22px",
                      position: "absolute",
                      bottom: "9px",
                      height: "20px",
                      borderRadius: "50px",
                      backgroundColor: "#ff7014",
                      justifyContent: "center",
                      textAlign: "center",
                      alignItems: "center",
                      color: "#fff",
                      fontSize: "14px",
                      left: "1px",
                    }}
                  >
                    <p style={{ margin: "0" }}>{context.BadgeOfBasket}</p>
                  </div>
                )}
              </div>
            </div>
             {
              context.uisetting!==null&&context.uisetting!==undefined?
               Object.values(context.uisetting).length>0&&
               context.uisetting.filterVisibility===true&&
            <div style={filterOrSortPart} className="filterOrSortPart">
              <div
                className="FilterOrSort"
                onClick={() => history.push("/searchsortorder")}
              >
                <div className="divofsearchSort">
                  <img
                    alt="image"
                    src="images/sort.png"
                    style={{
                      width: "17px",
                      transform: "translate(5px, 0)",
                    }}
                  />
                </div>

                <div
                  onClick={() => history.push("/searchsortorder")}
                  className="divofsearchSort"
                >
                  <h3
                    style={{
                      fontSize: "14px",
                      wordSpacing: "-3px",
                      margin: "0",
                      color: "gray",
                      fontWeight: "bold",
                    }}
                  >
                    {`ترتیب نمایش ${" "} ${":"} ${" "} ${sortName}`}
                  </h3>
                </div>
              </div>
            </div>
            :
            null
             }

            
            <div className="filterOrSortPart">
              <p
                style={headerCat} >
                {context.headerCat}
              </p>
            </div>

            {/* نمایش برند ها */}
            {
            context.searchProducts!==null&&  context.searchProducts!==undefined?
            Object.values(context.searchProducts).length > 0 ? (
              context.searchProducts.brandList.length > 0 &&
              context.SelectedBrandsList.length === 0 ||
              context.goBrand===true? (
                <div  style={
                  filterOrSortPartBrands
                } className="filterOrSortPartBrands">
                  <div
                   
                  >
                    <img style={{ width: "100%" }} src={brands} />
                    <p
                      style={{
                        position: "absolute",
                        top: "20px",
                        right: "20px",
                        color: "#fff",
                        margin:"0"
                      }}
                    >
                      برندها
                    </p>
                  </div>

                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      flexDirection: "row",
                      overflowY: "scroll",
                      height: "100%",
                      justifyContent: "flex-start",
                      textAlign: "center",
                      alignItems: "center",
                    }}
                  >
                    {
                      context.goBrand===true?
                      <div
                      onClick={()=>removeFilter()}
                        style={{backgroundColor:"red",color:"#fff"}}
                        className="brands2"
                      >
                      حذف فیلتر
                      </div>
                      :
                      null
                    }
                    {
                    Object.values(context.searchProducts).length>0&&
                    context.searchProducts.brandList.map((i) => (
                      <div
                        onClick={() => gobrands(i.name, i.id)}
                        className="brands2"
                      >
                        <p
                          style={{
                            margin: "0",
                            fontWeight: "bold",
                            fontSize: "13px",
                          }}
                        >
                          {i.name}
                        </p>
                        <img
                          className={
                            i.isSelected === true
                              ? "imgSelected"
                              : "imgNotSelected"
                          }
                          onError={addDefaultSrc}
                          src={i.img}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : null
            )
            :null 
            : null}

            {/* نمایش ساب کتگوری ها */}
            {context.category.length > 0 &&
            context.showCatId !== 0 &&
            context.BrandOfId !== 0 ||
            context.goBrand===true ? (
              <div style={
                filterOrSortPartBrands2
              } className="filterOrSortPartBrands2">
                <div
                  
                >
                  <img style={{ width: "100%" }} src={brands} />
                  <p
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      color: "#fff",
                      margin:"0"
                    }}
                  >
                    گروه کالایی
                  </p>
                </div>

                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    flexDirection: "row",
                    overflowY: "scroll",
                    height: "100%",
                    justifyContent: "flex-start",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  {context.category.map((i) => (
                    <div
                      onClick={() => goSub2(i.productGroupName, i.id)}
                      className="brands2"
                    >
                      <p
                        style={{
                          margin: "0",
                          fontWeight: "bold",
                          fontSize: "13px",
                          width: "100px",
                        }}
                      >
                        {i.productGroupName}
                      </p>
                      <img
                        className="imgSub"
                        onError={addDefaultSrc}
                        src={i.imageUrl}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>

          {
          context.searchProducts!==null&&context.searchProducts!==undefined?
          Object.values(context.searchProducts).length > 0 && (
            <InfiniteScroll
              className="InfiniteScroll"
              style={{
                overflow: "hidden",
              }}
              dataLength={context.searchProducts.productLists.length}
              next={fetchData}
              hasMore={true}
            >
              {context.searchProducts.productLists.length === 0 ? (
                <>
                  <img
                    alt="placeHolder"
                    src="/images/place_holder_cat_search.png"
                    style={{
                      marginTop: "100%",
                      width: "100%",
                      maxWidth: "200px",
                    }}
                  />
                  <p style={{ fontWeight: "bold" }}>کالایی موجود نیست!</p>
                </>
              ) : (
                <div
                  // style={catStyle}
                  // className={
                  //   context.showPre === false
                  //     ? "categoriesdivSub"
                  //     : "categoriesdivSubWidthPage"
                  // }
                  className="categoriesdivSub"
                >
                  {
                  context.searchProducts!==null&&
                  Object.values(context.searchProducts).length > 0
                    ? context.searchProducts.productLists.map((i) => (
                        <>
                          <div key={i.productCode} className="category">
                            <div
                              style={{
                                width: "100%",
                                maxWidth: "100%%",
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                textAlign: "center",
                                flexDirection: "row",
                                gap: "4.5px",
                              }}
                            >
                              <div
                                style={{
                                  width: "40%",
                           
                                }}
                              >
                                <img
                                  onClick={() => ModalImage(i.imageUrl)}
                                  onError={addDefaultSrc}
                                  style={{ width: "100%", height: "100%" }}
                                  src={i.imageUrl}
                                  className={
                                    parseInt(i.stock) === 0||parseInt(i.stock)<0
                                      ? "namojud"
                                      : "mojud"
                                  }
                                />
                              </div>

                              <div
                                onClick={() => ShowProductInfo(i)}
                                className="mainRowCat"
                                style={{ width: "60%", gap: "5px" }}
                              >
                                <div className="itemProduct">
                                  <p
                                    style={{
                                      color: "gray",
                                      fontWeight: "bold",
                                      margin: "0",
                                    }}
                                  >
                                    {i.brandName}
                                  </p>
                                </div>

                                <div className="itemProduct">
                                  <p
                                    style={{
                                      display: "flex",
                                      textAlign: "right",
                                      fontWeight: "bold",
                                      margin: "0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {i.productName}
                                  </p>
                                </div>

                                <div
                                  style={{ justifyContent: "space-between" }}
                                  className="itemProduct"
                                >
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      color: "gray",
                                      margin: "0",
                                    }}
                                  >
                                    قیمت مصرف کننده
                                  </p>

                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      color: "gray",
                                      margin: "0",
                                    }}
                                  >
                                    قیمت پایه
                                  </p>
                                </div>

                                <div
                                  style={{ justifyContent: "space-between" }}
                                  className="itemProduct"
                                >
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      margin: "0",
                                    }}
                                  >
                                    {" "}
                                    <NumberFormat
                                      value={i.userPrice}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                    />
                                      {" "}
                                      ریال
                                  </p>

                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      margin: "0",
                                    }}
                                  >
                                    <NumberFormat
                                      value={i.price}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                    />
                                        {" "}
                                      ریال
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                width: "100%",
                                maxWidth: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div
                                style={{
                                  width: "40%",
                                  height: "120px",
                                  height: "40px",
                                }}
                              >
                                {i.hasDiscountOffer !== "" ? (
                                  <button
                                    className="ButtonBtn"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: "50px",
                                      border: "1px solid #ff7014",
                                      backgroundColor: "#ff7014",
                                      color: "#fff",
                                    }}
                                  >
                                    {i.hasDiscountOffer}
                                  </button>
                                ) : null}
                              </div>
                               
                              {
                              i.basketSelection>0?
                              <div
                                style={{
                                  width: "30%",
                                  height: "35px",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                                className="itemProductRow"
                              >
                                {`${i.basketSelection} ${i.unitName}`}
                              </div>
                              :
                              <div
                              style={{
                                width: "30%",
                                height: "35px",
                                fontWeight: "bold",
                                fontSize: "14px",
                              }}
                              className="itemProductRow"
                            >
                              {`${i.unitName}`}
                            </div>
                               }

                              <div
                                style={{ width: "30%", height: "35px" }}
                                className="itemProductRow"
                              >
                                <BuyBtn Product={i} />
                              </div>
                            </div>
                          </div>
                        </>
                      ))
                    : <Preloader/>}
                </div>
              )}
              {context.showPre === true ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    alignAitem: "center",
                    marginBottom: "80px",
                    height: "80px",
                  }}
                >
                  <p
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      alignAitem: "center",
                      margin: "0",
                    }}
                  >
                    <Preloader2 />
                  </p>
                </div>
              ) : null}
            </InfiniteScroll>
          ):null}
        </>
      )}
        <Modal style={{ marginTop: "180px" }} show={showModal}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <img
            onError={addDefaultSrc}
            style={{ width: "100%" }}
            src={img}
          />
          <Button
            onClick={() => setshowModal(false)}
            style={{
              width: "90%",
              backgroundColor: "#ff7014",
              color: "#fff",
              height: "5vh",
              border: "none",
              margin: "10px 0 10px 0",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignAitem: "center",
            }}
          >
            بستن
          </Button>
        </div>
      </Modal>
    </div>
    }
    </>
  );
};

export default CategoriesProducts;
